import { render, staticRenderFns } from "./Controllers.vue?vue&type=template&id=bb5adcf2"
import script from "./Controllers.vue?vue&type=script&lang=js"
export * from "./Controllers.vue?vue&type=script&lang=js"
import style0 from "./Controllers.vue?vue&type=style&index=0&id=bb5adcf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports